import React from 'react';
import { motion } from 'framer-motion';

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-darkBg">
      <div className="text-center">
        <motion.div
          className="text-6xl font-oswald font-bold uppercase mb-4"
          animate={{
            textShadow: [
              '0 0 10px rgba(250, 255, 0, 0.8)',
              '0 0 30px rgba(0, 240, 255, 0.8)',
              '0 0 10px rgba(250, 255, 0, 0.8)',
            ],
          }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <span className="text-cyberYellow">DEV</span>{' '}
          <span className="text-electricBlue">BODYFLEX</span>
        </motion.div>
        <motion.div
          className="h-2 w-64 mx-auto bg-darkSubtle rounded-full overflow-hidden"
        >
          <motion.div
            className="h-full bg-gradient-to-r from-neonRed via-electricBlue to-neonRed"
            animate={{
              x: ['-100%', '100%'],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'linear',
            }}
          />
        </motion.div>
        <p className="mt-4 font-orbitron text-electricBlue text-sm tracking-wider">
          LOADING SYSTEMS...
        </p>
      </div>
    </div>
  );
};

export default Loader;